import { createSelector } from 'reselect';

import type { ReduxState } from '..';

export const root = (globalState: Pick<ReduxState, 'lockStatus'>) => globalState.lockStatus;

export const lockStatusSelector = createSelector([root], (lockStatus) => lockStatus);
